import React from "react";
import { useRouteError } from "react-router-dom";
import { Helmet } from "react-helmet";

const ErrorPage = () => {
    const error = useRouteError() as { statusText: string, message: string };
    if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error(error);
    }

    return (
        <div id="error-page">
            {/* Unknown addresses land here with a 200 response; keep them out of search */}
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            {process.env.NODE_ENV === "development" && (
                <p>
                    <i>{error.statusText || error.message}</i>
                </p>
            )}
        </div>
    );
};

export default ErrorPage;
